/**
 * TypingIndicator — the single three-dot typing bubble shared across the chat-
 * reveal activities (Fill, Sentence). iOS ships ONE
 * `flight-school/components/TypingIndicator` imported by every feature; this is
 * its web equivalent so Fill/Sentence stop each inlining their own near-
 * identical copy + @keyframes.
 *
 * The bubble background is variant-aware (`isFeed`): the feed renders dark grey
 * chat bubbles, the lesson white.
 */
import { colors } from "@/ui";

export interface TypingIndicatorProps {
  /** Feed = dark grey bubble; lesson (default) = white bubble. */
  isFeed?: boolean;
}

export default function TypingIndicator({ isFeed = false }: TypingIndicatorProps) {
  return (
    <div style={{ alignSelf: "flex-start" }}>
      <style>
        {`@keyframes activityTypingBounce {
          0%, 60%, 100% { transform: translateY(0); opacity: 0.4; }
          30% { transform: translateY(-4px); opacity: 1; }
        }`}
      </style>
      <div
        style={{
          backgroundColor: isFeed ? colors.greyChatBubble : colors.white,
          borderRadius: 16,
          padding: "12px 16px",
          display: "flex",
          gap: 5,
          boxShadow: "0 1px 8px rgba(0,0,0,0.05)",
        }}
      >
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            style={{
              width: 7,
              height: 7,
              borderRadius: "50%",
              backgroundColor: colors.muted,
              animation: "activityTypingBounce 1.2s infinite",
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
}
